import { ScheduleTypeEnum } from "./ScheduleTypeEnum";
import { ScheduleFrequencyEnum } from "./ScheduleFrequencyEnum";
import { DayOfWeek } from "./DayOfWeek";

export class ScheduleConfiguration {
    scheduleType: ScheduleTypeEnum = ScheduleTypeEnum.Update;

    frequency: ScheduleFrequencyEnum = ScheduleFrequencyEnum.NotSet;

    time: String = null;

    days: DayOfWeek = DayOfWeek.Monday;

    monthOccurence: Number = null;

    constructor() {}

    public parse(obj: any) {
        if (obj.ScheduleType != null || obj.ScheduleType != undefined) this.scheduleType = obj.ScheduleType;
        if (obj.Frequency != null || obj.Frequency != undefined) this.frequency = obj.Frequency;
        if (obj.Time != null || obj.Time != undefined) this.time = obj.Time;
        if (obj.Days != null || obj.Days != undefined) this.days = obj.Days;
        if (obj.MonthOccurence != null || obj.MonthOccurence != undefined) this.monthOccurence = obj.MonthOccurence;
    }
}
